import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import { useEffect } from 'react'

import { getDirection, getTranslate } from '../../localization'
import useStyles from './index.styles'

export interface RedirectModalProps {
  title: string
  isOpen: boolean
  onClose: () => void
  onClick: () => void
}

export const RedirectModal: React.FC<RedirectModalProps> = ({
  title,
  isOpen,
  onClose,
  onClick
}) => {
  const classes = useStyles()

  useEffect(() => {
    let timer: NodeJS.Timeout

    if (isOpen) {
      timer = setTimeout(() => {
        onClick() // trigger redirect automatically
      }, 5000) // 5 sec
    }

    return () => {
      clearTimeout(timer) // cleanup when modal closes/unmounts
    }
  }, [isOpen, onClick])

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <div className={classes.header}>
            <WarningRoundedIcon className={classes.icon} />
            <Typography variant="h4" className={classes.title}>
              {getTranslate(title)}
            </Typography>
          </div>
          <div className={classes.buttonsContainer}>
            <Button
              variant="contained"
              className={classes.deleteButton}
              onClick={onClick}
              color="primary">
              <Typography variant="h5" className={classes.changeText}>
                {getTranslate('Redirect')}
              </Typography>
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
